module.exports = __webpack_public_path__ + "img/vstock.9e3e88ae.png";